
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import PostMetadataBasicFields from "./PostMetadataBasicFields";
import PostMetadataThemeSelector from "./PostMetadataThemeSelector";
import PostMetadataSeoDescription from "./PostMetadataSeoDescription";
import PostMetadataCategories from "./PostMetadataCategories";
import PostMetadataFeaturedImage from "./PostMetadataFeaturedImage";

interface PostMetadataProps {
  title: string;
  setTitle: (title: string) => void;
  slug: string;
  setSlug: (slug: string) => void;
  excerpt: string;
  setExcerpt: (excerpt: string) => void;
  author: string;
  setAuthor: (author: string) => void;
  seoDescription: string;
  setSeoDescription: (seoDescription: string) => void;
  theme: string;
  setTheme: (theme: string) => void;
  categories: string[];
  setCategories: (categories: string[]) => void;
  featuredImage: string;
  setFeaturedImage: (url: string) => void;
  featuredImageAlt: string;
  setFeaturedImageAlt: (alt: string) => void;
  featuredImageTitle: string;
  setFeaturedImageTitle: (title: string) => void;
  onFileUpload?: (file: File) => Promise<string>;
}

const PostMetadata: React.FC<PostMetadataProps> = ({
  title,
  setTitle,
  slug,
  setSlug,
  excerpt,
  setExcerpt,
  author,
  setAuthor,
  seoDescription,
  setSeoDescription,
  theme,
  setTheme,
  categories,
  setCategories,
  featuredImage,
  setFeaturedImage,
  featuredImageAlt,
  setFeaturedImageAlt,
  featuredImageTitle,
  setFeaturedImageTitle,
  onFileUpload,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Post Details</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-6">
            {/* First column: Title, URL Slug, Excerpt, SEO Meta Description, Author */}
            <PostMetadataBasicFields
              title={title}
              setTitle={setTitle}
              slug={slug}
              setSlug={setSlug}
              excerpt={excerpt}
              setExcerpt={setExcerpt}
              author={author}
              setAuthor={setAuthor}
            />
            
            {/* SEO Description moved to first column */}
            <PostMetadataSeoDescription
              seoDescription={seoDescription}
              setSeoDescription={setSeoDescription}
            />
          </div>

          <div className="space-y-6">
            {/* Second column: Featured Image, Theme, Categories */}
            <PostMetadataFeaturedImage
              featuredImage={featuredImage}
              setFeaturedImage={setFeaturedImage}
              featuredImageAlt={featuredImageAlt}
              setFeaturedImageAlt={setFeaturedImageAlt}
              featuredImageTitle={featuredImageTitle}
              setFeaturedImageTitle={setFeaturedImageTitle}
              onFileUpload={onFileUpload}
            />

            {/* Theme selector moved to second column */}
            <PostMetadataThemeSelector
              theme={theme}
              setTheme={setTheme}
            />

            <PostMetadataCategories
              categories={categories}
              setCategories={setCategories}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PostMetadata;
